<template>
  <div>
    <div class="flex-x-center" v-show="projectDetail.project_info.exami_type === '研究生招生考试'">
      <div class="profile-content">
        <div class="flex-x-center">
          <form-create v-model="fApi" :rule="fRule" :option="option"></form-create>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { erroralert, successalert } from "@/utils/alert";
import { reqProjectSavedata, reqProjectDetail } from "@/api";
export default {
  data() {
    return {
      // 实例对象
      fApi: {},

      // 表单生成规则数组对象  生成规则：http://www.form-create.com/v2/guide/rule.html
      // 生成规则数组中一个对象就是一个表单项（是一个json对象），在里面可以对应的表单名称、类型、属性、值、样式、类名、是否必填、错误提示等。

      // 组件参数配置
      option: {
        // 显示重置表单按扭
        resetBtn: false,
        submitBtn: {
          //按钮文字提示
          innerText: "确认提交",
          //设置按钮为加载中状态

          show: true,
        },
        // 表单提交按扭事件
        //上传组件全局配置
        global: {
          upload: {
            //上传文件之前的钩子，参数为上传的文件，若返回 false 或者 Promise 则停止上传
            beforeUpload: () => { },
            //文件上传时的钩子，返回字段为 event, file, fileList
            onProgress: (event, file, fileList) => { },
            //文件上传成功时的钩子，返回字段为 response, file, fileList,若需有把文件添加到文件列表中,在函数值返回即可
            onSuccess: (response, file, fileList) => {
              consoel.log(response);
              alert("sddsd");
              // return 'filePath';
            },
            //文件上传失败时的钩子，返回字段为 error, file, fileList
            onError: (error, file, fileList) => { },
            //点击已上传的文件链接时的钩子，返回字段为 file， 可以通过 file.response 拿到服务端返回数据
            onPreview: (file) => { },
            //文件列表移除文件时的钩子，返回字段为 file, fileList
            onRemove: (file, fileList) => { },
            //文件格式验证失败时的钩子，返回字段为 file, fileList
            onFormatError: (file, fileList) => { },
            //文件超出指定大小限制时的钩子，返回字段为 file, fileList
            onExceededSize: (file, fileList) => { },
            //辅助操作按钮的图标 ,设置为false将不显示
            handleIcon: "ios-eye-outline",
            //点击辅助操作按钮事件
            onHandle: (src) => { },
            //是否可删除,设置为false是不显示删除按钮
            allowRemove: true,
          },
        },
        onSubmit: (formData) => {
          // alert(JSON.stringify(formData));
          if (this.$parent.projectDetail.current_step != this.process_index) {
            this.$message.error("当前状态无法提交更改");
            return false;
          }
          let formobj = this.fApi.formData();
          formobj.project_id = this.$parent.projectDetail.project_info.id;
          reqProjectSavedata(formobj).then((res) => {
            if (res.data.code === 1) {
              //保存成功
              var temp_project_id = this.$parent.projectDetail.project_info.id;
              var temp_param = {
                project_id: temp_project_id,
                step_name: "bkxx2",
              };
              reqProjectDetail(temp_param).then((res) => {
                if (res.data.code === 1) {
                  this.changeProject(res.data.data);
                  //调用父组件，进入下一步
                  this.$parent.next();
                } else {
                  this.$parent.next();
                  this.$message.success("资料已保存，请等待页面跳转");
                }
              });

              // this.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          });
        },
      },
    };
  },
  props: {
    // 流程
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  methods: {
    ...mapActions(useMainStore, {
      changeProject: "updateProjectDetail",
    }),
  },
  computed: {
    ...mapState(useMainStore, {
      projectDetail: "getProjectDetail",
    }),
    fRule() {
      return this.process && this.process.content && this.process.content.field_list
        ? this.process.content.field_list
        : [];
    }
  },
  mounted() { },
};
</script>

<style scoped>
.hide-button {
  display: none !important;
}

.testprofile {
  width: 100%;
}

.examination-subjects {
  margin-top: 30px;
  margin-left: 30px;
}

.testArea-applyPlace {
  width: 80%;
  margin-left: 10%;
}

.inner-button {
  margin-left: 30px;
  margin-top: 20px;
}

.top-button {
  margin-left: 30px;
  margin-top: 30px;
}

.check {
  width: 80px;
  height: 40px;
  border-radius: 4px;
  border: none;
  margin: 26px 0px 0px 20px;
}

.data {
  color: rgb(110, 105, 105);
  font-size: 14px;
  margin-top: 20px;
}

.three-box {
  width: 80%;
  height: 140px;
  /* background-color: rgb(149, 121, 226); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.two-line {
  height: 30px;
  border-radius: 3px;
  background-color: rgb(248, 246, 246);
  font-size: 14px;
  color: rgb(126, 121, 121);
  margin-top: 20px;
  width: 90%;
}

.title {
  font-size: 17px;
  padding-top: 10px;
  margin-left: 5px;
  color: #000;
}

.two-box {
  width: 80%;
  height: 180px;
  /* background-color: rgb(176, 204, 100); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.positions {
  width: 250px;
  height: 40px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 40px 0px 0px 30px;
  border-radius: 4px;
  padding-left: 5px;
  line-height: 40px;
}

.position {
  width: 150px;
  height: 40px;
  border: rgb(231, 225, 225) 1px solid;
  margin: 25px 0px 0px 30px;
  border-radius: 4px;
  padding-left: 5px;
  line-height: 40px;
}

.position-texts {
  font-size: 14px;
  color: black;
  margin-left: 40px;
  margin-top: 30px;
}

.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(231, 225, 225);
  margin-top: 10px;
}

.wram-tip {
  font-size: 15px;
  margin-left: 40px;
  color: rgb(126, 121, 121);
}

.profile-content {
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 5px;
  box-sizing: border-box;
}

.one-box {
  width: 80%;
  height: 300px;
  /* background-color: turquoise; */
  margin-top: 30px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}

.title-apply-position {
  font-size: 16px;
  color: rgb(8, 8, 8);
  margin: 10px;
}
</style>
